export default __webpack_public_path__ + "static/media/drawing-woman5-focusfill.1b1a4aa0.svg";